import classNames from 'classnames'

import { IconComponent } from '../types'

type InputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> & {
  block?: boolean
  suffix?: React.ReactNode
  prefix?: React.ReactNode
  prefixIcon?: IconComponent
  suffixIcon?: IconComponent
  className?: string
  invalid?: boolean
  size?: 'small' | 'medium' | 'large'
}

export const Input: React.FC<InputProps> = ({
  block,
  suffix,
  prefix,
  prefixIcon: PrefixIcon,
  suffixIcon: SuffixIcon,
  className,
  invalid,
  size = 'medium',
  ...inputProps
}) => {
  return (
    <div
      className={classNames(
        className,
        'inline-flex bg-neutralBlack-50 rounded-lg border outline-none relative',
        'text-[14px] text-neutralBlack-500',
        invalid
          ? 'border-danger placeholder:text-danger focus-within:border-danger'
          : 'border-neutralBlack-50 placeholder:to-neutralBlack-300 focus-within:border-neutralBlack-400',
        {
          'w-full': block,
          'opacity-50 pointer-events-none': inputProps.disabled
        }
      )}
    >
      {(prefix || PrefixIcon) && (
        <div className="flex items-center justify-center h-10">
          {prefix || (PrefixIcon && <PrefixIcon className="size-6 ml-4 opacity-50" />)}
        </div>
      )}

      <input
        {...inputProps}
        className={classNames('bg-transparent outline-none flex-auto rounded-lg', {
          'h-[40px] px-4': size === 'medium',
          'h-10 px-3': size === 'small',
          'text-neutralBlack-800': inputProps.value && !invalid,
          'text-neutralBlack-300': !inputProps.value && !invalid,
          'text-danger': invalid
        })}
      />

      {suffix && (
        <div className="flex items-center justify-center h-12">
          {suffix || (SuffixIcon && <SuffixIcon className="size-6 mr-4 opacity-50" />)}
        </div>
      )}
    </div>
  )
}
